import { toast } from "react-toastify";
import { ReceiptAPI, UserAPI } from "../constants/apiRoutes";
import { userActions } from "../reducers/user";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewUser = (data, navigate) => {
  return async (dispatch) => {
    dispatch(userActions.actionStart());
    try {
      await apiService.post(UserAPI.create(), data);
      dispatch(userActions.actionSuccess("create"));
    } catch (err) {
      dispatch(userActions.clearError());
      handleError(err);
    }
  };
};

export const updateUser = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(userActions.actionStart());
    return apiService
      .put(UserAPI.update(id), data)
      .then((response) => {
        dispatch(userActions.actionSuccess("update"));
      })
      .catch((err) => {
        dispatch(userActions.clearError());
        handleError(err);
      });
  };
};

export const deleteUser = (id) => {
  return (dispatch) => {
    return apiService
      .delete(UserAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali korisnika", {
          theme: "colored",
        });

        dispatch(fetchUserList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserList = () => {
  return (dispatch) => {
    return apiService
      .get(UserAPI.list())
      .then((response) => {
        dispatch(userActions.fetchUserList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserFormList = () => {
  return (dispatch) => {
    return apiService
      .get(UserAPI.form())
      .then((response) => {
        dispatch(userActions.fetchUserFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUserById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(UserAPI.getById(id))
      .then((response) => {
        dispatch(userActions.fetchUserDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReceiptList = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.get())
      .then((response) => {
        dispatch(userActions.fetchReceiptList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReceiptById = (id) => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.getById(id))
      .then((response) => {
        dispatch(userActions.fetchReceiptDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchManualFinishCart = (id) => {
  return (dispatch) => {
    return apiService
      .post(ReceiptAPI.manualCart(id))
      .then((response) => {
        toast.success("Uspešno ste odobrili kupovinu", {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchManualChangeStatusDelivery = (id) => {
  return (dispatch) => {
    return apiService
      .put(ReceiptAPI.manualChangeDeliveryStatus(id))
      .then((response) => {
        toast.success("Uspešno ste promenili status dostave", {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchManualFiscalization = (id) => {
  return (dispatch) => {
    return apiService
      .post(ReceiptAPI.manualFiscalization(id))
      .then((response) => {
        toast.success("Uspešno ste fiskalizovali kupovinu", {
          theme: "colored",
        });
        dispatch(fetchReceiptList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deactivateUser = (id) => {
  return (dispatch) => {
    return apiService
      .put(UserAPI.deactivateUser(id))
      .then((response) => {
        toast.success("Uspešno ste deaktivirali korisnika", {
          theme: "colored",
        });

        dispatch(fetchUserList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const activateUser = (id) => {
  return (dispatch) => {
    return apiService
      .put(UserAPI.activateUser(id))
      .then((response) => {
        toast.success("Uspešno ste aktivirali korisnika", {
          theme: "colored",
        });

        dispatch(fetchUserList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
export const fetchTotalSalesDetail = () => {
  return (dispatch) => {
    return apiService
      .get(UserAPI.totalSalesDetail())
      .then((response) => {
        dispatch(userActions.fetchTotalSalesDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReceiptTotalSales = (year = "") => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptTotalSales(year))
      .then((response) => {
        if (year) {
          dispatch(userActions.fetchReceiptTotalSalesYear(response.data));
        } else {
          dispatch(userActions.fetchReceiptTotalSales(response.data));
        }
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptTotalSalesOnline = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptTotalSalesOnline())
      .then((response) => {
        dispatch(userActions.fetchReceiptTotalSalesOnline(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptTotalSalesDelivery = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptTotalSalesDelivery())
      .then((response) => {
        dispatch(userActions.fetchReceiptTotalSalesDelivery(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptTotalPrice = (year = "") => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptTotalPrice(year))
      .then((response) => {
        if (year) {
          dispatch(userActions.fetchReceiptTotalPriceYear(response.data));
        } else {
          dispatch(userActions.fetchReceiptTotalPrice(response.data));
        }
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptTotalPriceOnline = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptTotalPriceOnline())
      .then((response) => {
        dispatch(userActions.fetchReceiptTotalPriceOnline(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptTotalPriceDelivery = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptTotalPriceDelivery())
      .then((response) => {
        dispatch(userActions.fetchReceiptTotalPriceDelivery(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptPendingDeliveries = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptPendingDeliveries())
      .then((response) => {
        dispatch(userActions.fetchReceiptPendingDeliveries(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptMonthlySales = (year) => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptMonthlySales(year))
      .then((response) => {
        dispatch(userActions.fetchReceiptMonthlySales(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptMonthlyRevenue = (year) => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptMonthlyRevenue(year))
      .then((response) => {
        dispatch(userActions.fetchReceiptMonthlyRevenue(response.data));
      })
      .catch((err) => handleError(err));
  };
};

export const fetchReceiptLastReceipt = () => {
  return (dispatch) => {
    return apiService
      .get(ReceiptAPI.receiptLastReceipt())
      .then((response) => {
        dispatch(userActions.fetchReceiptLastReceipt(response.data));
      })
      .catch((err) => handleError(err));
  };
};
